const filterRewardTypesForExchange = ({ redemptionOptions }) => {
  return redemptionOptions
}

export default filterRewardTypesForExchange
